// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__GhwOL","header":"MessagesList_header__1RTl2","chat":"MessagesList_chat__2IreJ"};